import { Action } from 'redux';

export const MASS_UPLOAD_STATE_NAME = 'MassUpload';
export const MASS_UPLOAD_STATE_CUSTOM = 'individualMarket.custom';
export const MASS_UPLOAD_STATE_ENROLLMENT = 'individualMarket.enrollment';
export const MASS_UPLOAD_STATE_ELIGIBILITY = 'individualMarket.individualMarketEligibility';
export const MASS_UPLOAD_STATE_SUBSCRIBER = 'individualMarket.ratingInfo.subscriber.0';

export interface MassUploadStateStructure {
    [key: number]: any;
}
const INITIAL_STATE: MassUploadStateStructure = {
  
};

const CLEAR_SUB_STATE = 'CLEAR_SUB_STATE';
const CLEAR_ALL_STATES = 'CLEAR_ALL_STATES';

export class MassUploadAction implements Action {
  type: string;
  id?: number;
}

export function clearState(id: number): MassUploadAction {
  return { type: CLEAR_SUB_STATE, id };
}

export function clearAllStates(): MassUploadAction {
  return { type: CLEAR_ALL_STATES };
}

export function MassUpload(state: MassUploadStateStructure = INITIAL_STATE,action: MassUploadAction) {
  const copiedState: MassUploadStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    case CLEAR_SUB_STATE:
      copiedState[action.id] = null;
      return Object.assign({}, state, copiedState);
    case CLEAR_ALL_STATES:
      return {};

    default:
      return state;
  }
}
